import { get } from "db/api";

export const getPlan = async (id) => {
  try {
    const response = await get("/get-plan/" + id);
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
